import { name, version } from '../../../package.json';
import { Card, CardContent } from 'components/shadcn';
import { ENV_MODE } from '@/configs';
import { Badge } from '../components/shadcn/badge';

export const InfoRoute = () => {
  return (
    <div
      className="relative flex min-h-screen flex-col bg-[#111418] overflow-x-hidden"
      style={{ fontFamily: '"Space Grotesk", "Noto Sans", sans-serif' }}
    >
      <div className="flex h-full grow flex-col">
        <div className="px-10 md:px-40 flex flex-1 justify-center py-5">
          <div className="flex flex-col w-full max-w-[960px]">
            <div className="flex flex-wrap justify-between gap-3 p-4">
              <h1 className="text-white text-[32px] font-bold leading-tight tracking-tight min-w-72 uppercase">
                {name}
              </h1>
            </div>
            <Card className="bg-transparent border-none shadow-none text-white">
              <CardContent className="px-4">
                <h3 className="text-lg font-bold leading-tight tracking-[-0.015em] pt-4">
                  Hosted Environment
                </h3>

                <Badge>{ENV_MODE}</Badge>

                <h3 className="text-lg font-bold leading-tight tracking-[-0.015em] pt-4">
                  Build Version
                </h3>

                <Badge> {version}</Badge>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};
